import React from 'react';

import { ServiceMode } from 'generated/graphql-gateway';
import { t } from 'state/intl/translations';
import { TranslationKey } from 'state/intl/types';

interface IGetOrderConfirmationHeader {
  userName: string;
}

interface IGetOrderConfirmationInstructions {
  userName: string;
  serviceMode: ServiceMode;
  isMobileOrderForDriveThruLaneEnabled: boolean;
}

export const getOrderConfirmationHeader = ({ userName }: IGetOrderConfirmationHeader): string => {
  return t('orderIsBeingMadeYourWay', { userName });
};

export const getOrderConfirmationInstructions = ({
  userName,
  serviceMode,
  isMobileOrderForDriveThruLaneEnabled,
}: IGetOrderConfirmationInstructions): string | React.ReactNode | null => {
  let instructions: TranslationKey | '' = '';

  switch (serviceMode) {
    case ServiceMode.EAT_IN:
      instructions = 'orderConfirmationInstructionsConfirmed';
      break;
    case ServiceMode.TAKEOUT:
      instructions = 'orderConfirmationInstructionsTakeOut';
      break;
    case ServiceMode.DELIVERY:
      instructions = 'orderConfirmationInstructionsDelivery';
      break;
    case ServiceMode.DRIVE_THRU:
      instructions = isMobileOrderForDriveThruLaneEnabled
        ? 'orderConfirmationInstructionsMobileDriveThru'
        : 'orderConfirmationInstructionsDriveThru';
      break;
    case ServiceMode.MOBILE_ORDER_DRIVE_THRU:
      instructions = 'orderConfirmationInstructionsMobileDriveThru';
      break;
    default:
      instructions = '';
  }

  return instructions ? t(instructions, { userName }) : null;
};
